// Use this hook to trigger Plausible events.
// The function is called in the following format:
// const plausible = usePlausible();
// plausible('Was this helpful? (Yes)', {
//   props: {
//     Page: 'page_slug',
//   },
// })

import { usePlausible as useNextPlausible } from 'next-plausible';

type Events = {
  'Was this helpful? (Yes)': {
    Page: string;
  };
  'Was this helpful? (No)': {
    Page: string;
  };
};

// eslint-disable-next-line
export function usePlausible() {
  return useNextPlausible<Events>();
}
